<template>
    <div class="form-group">
        <label class="control-label" for="JourneyName">{{resource('JourneyBuilderPublishModel_Name_DisplayName')}}</label>
        <input class="form-control"
               data-val="true"
               data-val-required="Het veld naam is verplicht"
               id="JourneyName"
               name="JourneyName"
               type="text"
               :disabled="!canWrite"
               v-model="journeyNameModel">

        <template v-if="$v.journeyNameModel.$dirty && $v.journeyNameModel.$invalid">
            <required-error-message v-if="!$v.journeyNameModel.required" :field-name="resource('JourneyBuilderPublishModel_Name_DisplayName')" />
            <max-length-error-message v-if="!$v.journeyNameModel.maxLength" :field-name="resource('JourneyBuilderPublishModel_Name_DisplayName')" :max-length="255" />

            <br />
        </template>

        <br />
        <span ref="activateToggle">
            <toggle-button :value="journeyIsActive"
                           @change="$emit('update:journeyIsActive', $event.value)"
                           :sync="true"
                           :labels="{checked: resource('Bool_Active'), unchecked: resource('Bool_Inactive')}"
                           :width="78"
                           :disabled="!hasActivationPermission" />
        </span>
        <br />

        <label class="control-label" for="JourneyWorld">{{resource('JourneyBuilderPublishModel_World_DisplayName')}}</label>
        <v-select v-if="journeyWorlds.length > 0" class='form-control'
                  v-model="worldModel"
                  :options="journeyWorlds"
                  label="name"
                  :clearable="true"
                  searchable
                  filterable
                  taggable
                  close-on-select
                  :disabled="!canWrite">
            <div slot='no-options' />
        </v-select>
        <br />

        <label class="control-label" for="JourneyType">{{resource('JourneyBuilderPublishModel_Type_DisplayName')}}</label>
        <v-select class='form-control'
                  v-model="typeModel"
                  :options="journeyTypes"
                  label="name"
                  :clearable="false"
                  taggable
                  close-on-select
                  :disabled="!canWrite"> 
            <div slot='no-options' />
        </v-select>

        <br />
        <label class="control-label" for="journey-division-dropdown">{{resource('JourneyBuilderPublishModel_DivisionId_DisplayName')}}</label>

        <template v-if="divisionList">
            <division-dropdown v-model="journeyDivisionIdModel"
                               v-bind:division-list="divisionList"

                               id="journey-division-dropdown"
                               :disabled="!canWrite">
            </division-dropdown>
        </template>
        <template v-else>
            <!-- Placeholder -->
            <select class="form-control" />
        </template>

        <br />

        <label class="control-label" for="JourneyStartDate">{{resource('JourneyBuilderPublishModel_StartDate_DisplayName')}}</label>
        <datepicker id="JourneyStartDate"
                    name="JourneyStartDate"
                    :value="startDate"
                    @input="updateStartDate"
                    :options="startDatePickerOptions">
        </datepicker>

        <label class="control-label" for="JourneyEndDate">{{resource('JourneyBuilderPublishModel_EndDate_DisplayName')}}</label>
        <datepicker id="JourneyEndDate"
                    name="JourneyEndDate"
                    :value="endDate"
                    @input="updateEndDate"
                    :options="endDatePickerOptions">
        </datepicker>

        <label class="control-label" for="JourneyDescription">{{resource('JourneyBuilderPublishModel_Description_DisplayName')}}</label>
        <textarea rows="7"
                  class="form-control"
                  id="JourneyDescription"
                  :disabled="!canWrite"
                  :value="journeyDescription"
                  @change="$emit('update:journeyDescription', $event.target.value)" />
    </div>
</template>

<script>
    import {required, maxLength} from 'vuelidate/lib/validators';
    
    import {validationMixin} from 'vuelidate';
    import tooltipMixin from '@core/Util/Mixins/tooltips';
    import resources from "@core/Util/Mixins/resources";
    import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';
    import dateHelpers from '@modules/JourneyBuilder/Util/date-helpers';

    import VSelect from 'vue-select';
    import Datepicker from "@core/Components/Util/DatePicker.vue";
    import DivisionDropdown from "@core/Components/Util/DivisionDropdown";
    import RequiredErrorMessage from "@core/Components/Errors/RequiredErrorMessage.vue";
    import MaxLengthErrorMessage from "@core/Components/Errors/MaxLengthErrorMessage.vue";
    import { ToggleButton } from 'vue-js-toggle-button';

    import api from '@modules/JourneyBuilder/api';
    import $ from 'jquery';
    import divisionApi from "@core/Api/divisions";
    import {bootstrapDangerGrowl} from "@core/Util/growler";

    export default {
        name: 'menu-edit-form',
        components: {
            Datepicker,
            DivisionDropdown,
            RequiredErrorMessage,
            MaxLengthErrorMessage,
            VSelect,
            ToggleButton
        },
        mixins: [resources, permissionsMixin, validationMixin, tooltipMixin],
        validations: {
            journeyNameModel: {
                required,
                maxLength: maxLength(255)
            }
        },
        created() {
            divisionApi.getDivisionsList({ includeDisabled: true })
                .then(divisions => this.divisionList = divisions, bootstrapDangerGrowl);
            
            api.getWorlds().then(
                (worlds) => { 
                    this.journeyWorlds = worlds; 
                },
                bootstrapDangerGrowl
            );

            api.getTypes().then(
                (types) => {
                    this.journeyTypes = types;
                },
                bootstrapDangerGrowl
            );//TODO: implement getTypes()
        },
        computed: {
            journeyNameModel: {
                get(){
                    return this.journeyName;
                },
                set(value){
                    this.$v.journeyNameModel.$touch();
                    this.$emit('update:journeyName', value);
                }
            },
            worldModel: {
                get() {
                    return this.journeyWorlds.find((world) => world.id === this.journeyWorld);
                },
                set(value) {
                    this.$emit('update:journeyWorld', value != null ? value.id : null);
                }
            },
            journeyDivisionIdModel: {
                get(){
                    return this.journeyDivisionId;
                },
                set(value){
                    this.$emit('update:journeyDivisionId', value);
                }
            },
            typeModel: {
                get() {
                    return this.journeyTypes.find((type) => type.id === this.journeyType);
                },
                set(value) {
                    this.$emit('update:journeyType', value.id);
                }
            },
            startDate(){
                return this.journeyStartDate ? dateHelpers.getDateFromString(this.journeyStartDate) : undefined;
            },
            endDate(){
                return this.journeyEndDate ? dateHelpers.getDateFromString(this.journeyEndDate) : undefined;
            },
            
            startDatePickerOptions(){
                return {
                    clearButton: this.canWrite,
                    disabled: !this.canWrite,
                    required: false,
                    typeable: false,
                    
                    disabledDates: {
                        from: undefined,
                        to: new Date(0)
                    }
                };
            },
            endDatePickerOptions(){
                return {
                    clearButton: this.canWrite,
                    disabled: !this.canWrite,
                    required: false,
                    typeable: false,

                    disabledDates: {
                        from: undefined,
                        to: this.startDate || new Date(0)
                    }
                };
            }
        },
        methods: {
            updateStartDate(date){
                //EndDate always has to be equal; or greater than our startDate
                if(date > this.endDate){
                    this.updateEndDate(undefined);
                }
                
                this.emitDateChange('update:journeyStartDate', date);
            },
            updateEndDate(date){
                this.emitDateChange('update:journeyEndDate', date);
            },
            emitDateChange(event, date){
                if(date){
                    date = dateHelpers.getStringifiedDate(date);
                }

                this.$emit(event, date);
            }
        },
        data() {
            return {
                journeyWorlds: [],
                journeyTypes: [],
                divisionList: undefined
            }
        },
        watch: {
            //hasActivationPermission is initialized as null
            //When it is changed to it's actual value after an api call
            //This watcher will be triggered.
            hasActivationPermission(value) {
                if(!value) {
                    var toggle = $(this.$refs.activateToggle);
                    toggle.attr('data-toggle', 'tooltip');
                    toggle.attr('data-placement', 'top');
                    toggle.attr('title', this.resource('JourneyBuilder_Menu_Activation_Denied_Message'));
                    this.initializeTooltips();
                }
            }
        },
        props: {
            journeyName: String,
            journeyDescription: String,
            journeyStartDate: String,
            journeyEndDate: String,
            journeyWorld: String,
            journeyIsActive: Boolean,
            journeyDivisionId: String,
            journeyType: Number
        }
    }
</script>